/* eslint-disable */
import React, { useState } from "react";

const UserListFilterPopup = ({
  setfilterName,
  setfilterLocation,
  setfilterCountry,
  setfilterZipcode,
  setfilterCompany,
  setfilterMyConnect,
}) => {
  const token = localStorage.getItem("token");

  const [name, setname] = useState("");
  const [city, setcity] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [company, setcompany] = useState("");
  const [myConnect, setmyConnect] = useState(false);

  const searchDataHandler = () => {
    if (name != "") {
      setfilterName(name);
    }
    if (city != "") {
      setfilterLocation(city);
    }
    if (country != "") {
      setfilterCountry(country);
    }
    if (zipcode != "") {
      setfilterZipcode(zipcode);
    }
    if (company != "") {
      setfilterCompany(company);
    }
    if (myConnect != "") {
      setfilterMyConnect(myConnect);
    }
    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#networkFilter");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
    resetHandler();
  };

  //reset
  const resetHandler = () => {
    setname("");
    setcity("");
    setcountry("");
    setzipcode("");
    setcompany("");
    setmyConnect(false);
  };

  return (
    <div className="offcanvas_sidebar">
      <div
        className="offcanvas offcanvas-end body_bg"
        tabIndex="-1"
        id="networkFilter"
        aria-labelledby="offcanvasTopLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="close-btn text-reset filter_cross d-flex align-items-center justify-content-center"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="filter_outerbx">
            {/* name */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search By Name
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <input
                    className="form-control"
                    placeholder="Search By Name"
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setname(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* location */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search By location
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <input
                    className="form-control"
                    placeholder="Search By Location"
                    type="text"
                    value={city}
                    onChange={(e) => {
                      setcity(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* country */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search By Country
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <input
                    className="form-control"
                    placeholder="Search By Country"
                    type="text"
                    value={country}
                    onChange={(e) => {
                      setcountry(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* zipcode */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search By Zipcode
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <input
                    className="form-control"
                    placeholder="Search By zipcode"
                    type="text"
                    value={zipcode}
                    onChange={(e) => {
                      setzipcode(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Company */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search By Company
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <input
                    className="form-control"
                    placeholder="Search By Location"
                    type="text"
                    value={company}
                    onChange={(e) => {
                      setcompany(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* my connect */}
            {token && (
              <div className="product_filtr_item mb-3">
                <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                  {/* <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    My Connection
                  </h4>
                </div> */}
                  {/* <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span> */}
                </div>
                <div className="filter_info">
                  <div className="filter_list department_info">
                    <label className="radio-check">
                      <input
                        type="checkbox"
                        checked={myConnect}
                        onChange={(e) => {
                          setmyConnect(e.target.checked);
                        }}
                      />
                      <span></span>
                      <p className="fs-sm text-primary fw-medium">
                        My Connection
                      </p>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button
            type="button"
            className="btn primary-btn fs-sm fw-normal w-100 mt-4"
            onClick={searchDataHandler}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserListFilterPopup;
